import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import Api from "@/api/index";
import defaultErrorPaginate from "@/api/defaultErrorPaginate";
import AuthenticationService from "@/services/AuthenticationService";

const ujian = {
  namespaced: true,
  state: {
    loading: false,
    datas: {},
    event: {},
    my: {},
    students: [],
    queryParam: {},
    modalAbsen: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    getEvent(state) {
      return state.event;
    },
    getMy(state) {
      return state.my;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_EVENT(state, datas) {
      state.event = datas;
    },
    SET_MY(state, datas) {
      state.my = datas;
    },
    SET_STUDENTS(state, datas) {
      state.students = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_ABSEN(state, data) {
      state.modalAbsen = data;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("ujian/student/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    onRefresh({ state }) {
      store.dispatch("ujian/paginate", state.queryParam);
    },
    setState({ state }, payload) {
      state[payload[0]] = payload[1];
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Update") {
        commit("SET_MODAL_ABSEN", true);
        store.dispatch("ujian/getEvent", payload[0]["event_id"]);
        store.dispatch("ujian/getStudentEvent", payload[0]["event_id"]);
      }
    },
    async getEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("backoffice/event/" + payload).then(({ data }) => {
        commit("SET_EVENT", data.record);
        commit("SET_MY", data.account);
        commit("SET_LOADING", false);
      });
    },
    async getStudentEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("students/event/" + payload).then(({ data }) => {
        commit("SET_STUDENTS", data);
        commit("SET_LOADING", false);
      });
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `ujian/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      state.event.students = payload;
      return await AuthenticationService.post(
        "backoffice/attendances/student",
        state.event
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_ABSEN", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("ujian/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default ujian;
